<template>
  <div class="my-index-skeleton">
    <div data-v-5acd8b24="" data-v-55f6985a="" data-v-82a49174="" class="tab-bar-layout page-my sk-pseudo sk-pseudo-circle">
      <div data-v-267e34da="" data-v-55f6985a="" class="my-header-component sk-pseudo sk-pseudo-circle" data-v-5acd8b24="">
        <a data-v-267e34da="" href="/login?redirectTo=%2Fmy" class="my-settings sk-rect sk-pseudo sk-pseudo-circle">
          <div data-v-267e34da="" class="info sk-pseudo sk-pseudo-circle">
            <span data-v-75fd2268="" data-v-267e34da="" class="avatar-component user-avatar size-medium sk-pseudo sk-pseudo-circle" style=border:none>
              <div data-v-75fd2268="" class="ym-image sk-pseudo sk-pseudo-circle" style=overflow:hidden;border-radius:50%><img src=data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7 class="ym-image-img sk-image sk-rect sk-pseudo sk-pseudo-circle" style=object-fit:fill width=55.1875 height=55.1875>
              </div>
            </span>
            <div data-v-267e34da="" class="text sk-pseudo sk-pseudo-circle">
              <div data-v-267e34da="" class="user-info sk-pseudo sk-pseudo-circle">
                <h1 data-v-267e34da="" class="name sk-transparent sk-text-14-0000 sk-text sk-pseudo sk-pseudo-circle" style="background-size:100% 0.667rem">
                  用户名称
                </h1>
                <h1 data-v-267e34da="" class="name sk-transparent sk-text-14-0000 sk-text sk-pseudo sk-pseudo-circle" style="background-size:100% 0.667rem">
                  积分中心
                </h1>
              </div>
            </div>
          </div>
        </a>
      </div>

      <div data-v-649c42ce="" data-v-55f6985a="" class="icon-grid-container sk-pseudo sk-pseudo-circle" data-v-5acd8b24="">
        <div data-v-649c42ce="" class="icon-grid-list sk-pseudo sk-pseudo-circle">
          <a data-v-649c42ce="" href=/my/order class="icon-grid-item sk-pseudo sk-pseudo-circle">
            <div data-v-649c42ce="" class="ym-image icon-grid-item-icon sk-pseudo sk-pseudo-circle"><img src=data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7 class="ym-image-img sk-image sk-rect sk-pseudo sk-pseudo-circle" style=object-fit:fill width=44.15625 height=44.15625>
            </div><span data-v-649c42ce="" class="text sk-transparent sk-text-0-0000 sk-text sk-pseudo sk-pseudo-circle" style="background-size:100% .3467rem;background-position-x:50%">我的订单</span>
          </a>
          <a data-v-649c42ce="" href=/my/group/purchase class="icon-grid-item sk-pseudo sk-pseudo-circle">
            <div data-v-649c42ce="" class="ym-image icon-grid-item-icon sk-pseudo sk-pseudo-circle"><img src=data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7 class="ym-image-img sk-image sk-rect sk-pseudo sk-pseudo-circle" style=object-fit:fill width=44.15625 height=44.15625>
            </div><span data-v-649c42ce="" class="text sk-transparent sk-text-0-0000 sk-text sk-pseudo sk-pseudo-circle" style="background-size:100% .3467rem;background-position-x:50%">我的拼团</span>
          </a>
          <a data-v-649c42ce="" href=/my/give/record class="icon-grid-item sk-pseudo sk-pseudo-circle">
            <div data-v-649c42ce="" class="ym-image icon-grid-item-icon sk-pseudo sk-pseudo-circle"><img src=data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7 class="ym-image-img sk-image sk-rect sk-pseudo sk-pseudo-circle" style=object-fit:fill width=44.15625 height=44.15625>
            </div><span data-v-649c42ce="" class="text sk-transparent sk-text-0-0000 sk-text sk-pseudo sk-pseudo-circle" style="background-size:100% .3467rem;background-position-x:50%">赠送记录</span>
          </a>
          <a data-v-649c42ce="" href=/my/coupon class="icon-grid-item sk-pseudo sk-pseudo-circle">
            <div data-v-649c42ce="" class="ym-image icon-grid-item-icon sk-pseudo sk-pseudo-circle"><img src=data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7 class="ym-image-img sk-image sk-rect sk-pseudo sk-pseudo-circle" style=object-fit:fill width=44.15625 height=44.15625>
            </div><span data-v-649c42ce="" class="text sk-transparent sk-text-0-0000 sk-text sk-pseudo sk-pseudo-circle" style="background-size:100% .3467rem;background-position-x:50%">优惠券啊</span>
          </a>
          <a data-v-649c42ce="" href=/my/collect class="icon-grid-item sk-pseudo sk-pseudo-circle">
            <div data-v-649c42ce="" class="ym-image icon-grid-item-icon sk-pseudo sk-pseudo-circle"><img src=data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7 class="ym-image-img sk-image sk-rect sk-pseudo sk-pseudo-circle" style=object-fit:fill width=44.15625 height=44.15625>
            </div><span data-v-649c42ce="" class="text sk-transparent sk-text-0-0000 sk-text sk-pseudo sk-pseudo-circle" style="background-size:100% .3467rem;background-position-x:50%">我的收藏</span>
          </a>
        </div>
      </div>

      <div data-v-55f6985a="" data-v-5acd8b24="" class="cell-container sk-pseudo sk-pseudo-circle">
        <a data-v-55f6985a="" href=/my/remind class="ym-cell cell-container-list ym-hairline--bottom" data-v-5acd8b24="">
          <div class="ym-cell-left sk-pseudo sk-pseudo-circle"><span data-v-55f6985a="" class="cell-icon my-round-remind sk-pseudo sk-pseudo-circle"><span data-v-55f6985a="" class="ym-icon ym-icon ym-icon--round-remind sk-pseudo sk-pseudo-circle sk-image" style=width:1em></span></span>
            <div class="ym-cell-title sk-pseudo sk-pseudo-circle"><span class="ym-cell-text sk-transparent sk-text-0-0000 sk-text sk-pseudo sk-pseudo-circle" style="background-size:100% 0.373rem">消息中心</span>
            </div>
          </div>
        </a>
        <a data-v-55f6985a="" href=/my/information class="ym-cell cell-container-list ym-hairline--bottom" data-v-5acd8b24="">
          <div class="ym-cell-left sk-pseudo sk-pseudo-circle"><span data-v-55f6985a="" class="cell-icon my-message sk-pseudo sk-pseudo-circle"><span data-v-55f6985a="" class="ym-icon ym-icon ym-icon--message sk-pseudo sk-pseudo-circle sk-image" style=width:1em></span></span>
            <div class="ym-cell-title sk-pseudo sk-pseudo-circle"><span class="ym-cell-text sk-transparent sk-text-0-0000 sk-text sk-pseudo sk-pseudo-circle" style="background-size:100% 0.373rem">帮助中心</span>
            </div>
          </div>
        </a>
        <a data-v-55f6985a="" href=/my/invitation class="ym-cell cell-container-list ym-hairline--bottom" data-v-5acd8b24="">
          <div class="ym-cell-left sk-pseudo sk-pseudo-circle"><span data-v-55f6985a="" class="cell-icon my-invite sk-pseudo sk-pseudo-circle"><span data-v-55f6985a="" class="ym-icon ym-icon ym-icon--invite sk-pseudo sk-pseudo-circle sk-image" style=width:1em></span></span>
            <div class="ym-cell-title sk-pseudo sk-pseudo-circle"><span class="ym-cell-text sk-transparent sk-text-0-0000 sk-text sk-pseudo sk-pseudo-circle" style="background-size:100% 0.373rem">意见反馈</span>
            </div>
          </div>
        </a>
        <a data-v-55f6985a="" href=/faq class="ym-cell cell-container-list ym-hairline--bottom sk-pseudo sk-pseudo-circle" data-v-5acd8b24="">
          <div class="ym-cell-left sk-pseudo sk-pseudo-circle"><span data-v-55f6985a="" class="cell-icon my-round-question sk-pseudo sk-pseudo-circle"><span data-v-55f6985a="" class="ym-icon ym-icon ym-icon--round-question sk-pseudo sk-pseudo-circle sk-image" style=width:1em></span></span>
            <div class="ym-cell-title sk-pseudo sk-pseudo-circle"><span class="ym-cell-text sk-transparent sk-text-0-0000 sk-text sk-pseudo sk-pseudo-circle" style="background-size:100% 0.373rem">开课提醒</span>
            </div>
          </div>
        </a>
        <a data-v-55f6985a="" href=/system/settings class="ym-cell cell-container-list ym-hairline--bottom" data-v-5acd8b24="">
          <div class="ym-cell-left sk-pseudo sk-pseudo-circle"><span data-v-55f6985a="" class="cell-icon my-setting sk-pseudo sk-pseudo-circle"><span data-v-55f6985a="" class="ym-icon ym-icon ym-icon--setting sk-pseudo sk-pseudo-circle sk-image" style=width:1em></span></span>
            <div class="ym-cell-title sk-pseudo sk-pseudo-circle"><span class="ym-cell-text sk-transparent sk-text-0-0000 sk-text sk-pseudo sk-pseudo-circle" style="background-size:100% 0.373rem">账号设置</span>
            </div>
          </div>
        </a>
        <a data-v-55f6985a="" href=/aboutus class="ym-cell cell-container-list ym-hairline--bottom" data-v-5acd8b24="">
          <div class="ym-cell-left sk-pseudo sk-pseudo-circle"><span data-v-55f6985a="" class="cell-icon my-aboutus sk-pseudo sk-pseudo-circle"><span data-v-55f6985a="" class="ym-icon ym-icon ym-icon--aboutus sk-pseudo sk-pseudo-circle sk-image" style=width:1em></span></span>
            <div class="ym-cell-title sk-pseudo sk-pseudo-circle"><span class="ym-cell-text sk-transparent sk-text-0-0000 sk-text sk-pseudo sk-pseudo-circle" style="background-size:100% 0.373rem">关于我们</span>
            </div>
          </div>
        </a>
      </div>
    </div>

    <div class=sk-loading></div>
  </div>
</template>

<script>
  export default {
    name: 'MyIndexSkeleton',
  };
</script>

<style scoped>
  .tab-bar-layout[data-v-5acd8b24] {
    min-height: 100%;
    padding-bottom: 1.6rem
  }

  .avatar-component[data-v-75fd2268] {
    -webkit-flex-shrink: 0;
    flex-shrink: 0;
    display: inline-block;
    width: 1.6rem;
    height: 1.6rem;
    border: 1px solid #eee;
    border-radius: 50%;
    position: relative
  }

  .avatar-component[data-v-75fd2268]::after {
    content: '';
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0
  }

  .avatar-component.size-medium[data-v-75fd2268] {
    width: 1.6rem;
    height: 1.6rem
  }

  .my-settings[data-v-267e34da] {
    background: url(/img/head_bg.abb67a78.png) 0 0/contain no-repeat;
    height: 5.86667rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    padding-left: 0.7333rem;
    box-sizing: border-box
  }

  .my-settings .info[data-v-267e34da] {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    -webkit-align-self: stretch;
    align-self: stretch;
    margin-bottom: 1.867rem;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between
  }

  .my-settings .user-info[data-v-267e34da] {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    flex-direction: column;
    align-items: center
  }

  .my-settings .text[data-v-267e34da] {
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    flex-direction: column;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: start;
    -webkit-align-items: flex-start;
    align-items: flex-start;
    line-height: 1
  }

  .my-settings .name[data-v-267e34da] {
    line-height: 0.667rem;
    font-size: 0.480rem;
    font-weight: 700;
    margin-top: 0.15rem;
    margin-bottom: 0.15rem;
    color: #fff
  }

  .user-avatar[data-v-267e34da] {
    -webkit-flex-shrink: 0;
    flex-shrink: 0;
    margin-right: 0.500rem
  }

  .icon-grid-container[data-v-649c42ce] {
    width: 9.2rem;
    margin: -2.26667rem auto 0.267rem;
    background-color: #fff;
    border-radius: 20px;
    overflow: hidden;
    z-index: 1000;
  }

  .icon-grid-list[data-v-649c42ce] {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
    background-color: #fff;
    padding-bottom: 0.66667rem
  }

  .icon-grid-item[data-v-649c42ce] {
    margin-top: 0.66667rem;
    -webkit-box-flex: 0;
    -webkit-flex: 0 0 33.33%;
    flex: 0 0 33.33%;
    text-align: center;
    line-height: 1;
    color: #666;
    font-size: 0.34667rem
  }

  .icon-grid-item-icon[data-v-649c42ce] {
    display: block;
    width: 1.06667rem;
    height: 1.06667rem;
    margin: 0 auto 0.26667rem
  }

  .cell-container[data-v-55f6985a] {
    margin-bottom: 0.26667rem;
  }

  .cell-container-list[data-v-55f6985a] {
    width: 9.200rem;
    margin: 0 auto;
    background: #fff
  }

  .cell-container-list[data-v-55f6985a]:not(:last-child) {
    position: relative
  }

  .cell-container-list[data-v-55f6985a]:not(:last-child)::after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0.533rem;
    width: 8.133rem;
    height: 1px;
    background: #eee
  }

  .cell-container-list[data-v-55f6985a]:first-child {
    border-radius: 12px 12px 0 0
  }

  .cell-container-list[data-v-55f6985a]:last-child {
    border-radius: 0 0 12px 12px
  }

  .cell-icon[data-v-55f6985a] {
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: inline-flex;
    vertical-align: middle;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    width: 0.480rem;
    height: 0.480rem;
    border-radius: 50%;
    color: #999;
    box-sizing: border-box;
    margin-right: 0.133rem
  }

  .cell-icon[data-v-55f6985a] .ym-icon {
    vertical-align: middle;
    font-size: 0.480rem
  }

  .my-round-question[data-v-55f6985a] {
    font-size: 0.427rem
  }

  .info-tips[data-v-55f6985a]::before {
    content: '';
    position: absolute;
    width: 0.187rem;
    height: 0.187rem;
    background: #fa405e;
    border-radius: 50%;
    left: -0.267rem;
    top: 0.107rem
  }

  .sk-transparent {
    color: transparent!important
  }

  .sk-circle {
    border-radius: 50%
  }

  .sk-svg {
    background: #efefef!important
  }

  .sk-opacity {
    opacity: 0!important
  }

  .sk-text-14-0000 {
    background-image: linear-gradient(transparent 14%,#eee 0,#eee 86%,transparent 0)!important;
    background-size: 100% 0.667rem;
    position: relative!important
  }

  .sk-text {
    background-origin: content-box!important;
    background-clip: content-box!important;
    background-color: transparent!important;
    color: transparent!important;
    background-repeat: repeat-y!important
  }

  .sk-text-14-2857 {
    background-image: linear-gradient(transparent 14.2857%,#eee 0,#eee 85.7143%,transparent 0)!important;
    background-size: 100% 0.448rem;
    position: relative!important
  }

  .sk-text-0-0000 {
    background-image: linear-gradient(transparent 0,#eee 0,#eee 100%,transparent 0)!important;
    background-size: 100% 0.373rem;
    position: relative!important
  }

  .sk-image {
    background: #efefef!important
  }

  .sk-rect {
    border-radius: 0
  }

  .sk-pseudo::after,.sk-pseudo::before {
    background: #efefef!important;
    color: transparent!important;
    border-color: transparent!important
  }

  .sk-pseudo-rect::after,.sk-pseudo-rect::before {
    border-radius: 0!important
  }

  .sk-pseudo-circle::after,.sk-pseudo-circle::before {
    border-radius: 50%!important
  }

  @keyframes flush {
    0% {
      left: -100%
    }

    50% {
      left: 0
    }

    100% {
      left: 100%
    }
  }

  .sk-loading {
    animation: 2s linear infinite flush;
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    background: linear-gradient(to left,rgba(255,255,255,0) 0,rgba(255,255,255,.85) 50%,rgba(255,255,255,0) 100%)
  }
</style>
